import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar onOpenModal={openModal} />
      <Hero onOpenModal={openModal} />
      <About onOpenModal={openModal} />
      <Services onOpenModal={openModal} />
      <Gallery />
      <Testimonials />
      <Contact onOpenModal={openModal} />
      <Footer />

      {/* Shared Consultation Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-3">
          <div 
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={closeModal}
          ></div>
          
          <div className="relative bg-white rounded-xl shadow-2xl max-w-sm w-full p-5 max-h-[90vh] overflow-y-auto">
            <button
              onClick={closeModal}
              className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-lg"></i>
            </button>

            <h3 className="text-xl font-serif font-semibold text-gray-900 mb-1">
              Schedule a Consultation
            </h3>
            <p className="text-gray-500 text-sm mb-4">
              Reach out to us to discuss your framing needs
            </p>

            <div className="space-y-3">
              <a 
                href="tel:+18187835274" 
                className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg hover:bg-[#D4B137]/10 transition-colors group cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#D4B137] rounded-full flex-shrink-0">
                  <i className="ri-phone-line text-lg text-white"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Call Us</p>
                  <p className="text-base font-medium text-gray-900 group-hover:text-[#D4B137] transition-colors">
                    (818) 783-5274
                  </p>
                </div>
              </a>

              <a 
                href="mailto:flashframers@yahoo.com" 
                className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg hover:bg-[#D4B137]/10 transition-colors group cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#D4B137] rounded-full flex-shrink-0">
                  <i className="ri-mail-line text-lg text-white"></i>
                </div>
                <div className="min-w-0">
                  <p className="text-xs text-gray-500">Email Us</p>
                  <p className="text-base font-medium text-gray-900 group-hover:text-[#D4B137] transition-colors truncate">
                    flashframers@yahoo.com
                  </p>
                </div>
              </a>

              <div className="p-3 bg-gray-50 rounded-lg">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#D4B137] rounded-full flex-shrink-0">
                    <i className="ri-time-line text-lg text-white"></i>
                  </div>
                  <p className="text-base font-medium text-gray-900">Business Hours</p>
                </div>
                <div className="ml-13 pl-[52px] space-y-0.5 text-sm text-gray-600">
                  <p className="flex justify-between">
                    <span>Monday</span>
                    <span className="font-medium text-red-500">Closed</span>
                  </p>
                  <p className="flex justify-between">
                    <span>Tue - Fri</span>
                    <span className="font-medium">10:00 AM - 5:00 PM</span>
                  </p>
                  <p className="flex justify-between">
                    <span>Saturday</span>
                    <span className="font-medium">11:00 AM - 5:00 PM</span>
                  </p>
                  <p className="flex justify-between">
                    <span>Sunday</span>
                    <span className="font-medium text-[#D4B137]">By Appointment</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
